




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MelosButtonSet from '@/components/MelosButtonSet.vue';

@Component({
  components: {
    MelosButtonSet,
  },
})
export default class MelosButton extends Vue {
  @Prop() private label!: string;

}

